module.exports = __webpack_public_path__ + "r-v3/img/menu_white.2c6c38bb.svg";